import API from 'files/api.js';

const buildRequest = (url, props) => {
    let newURL = `${url}?type=${props.type}`;
    for(var i in props) {
        if(i == 'type') {
            continue;
        }
        newURL += `&${i}=${typeof(props[i]) === 'object' ? JSON.stringify(props[i]) : encodeURIComponent(props[i])}`;
    }
    return newURL;
}

const get = (utils, url, props) => {
    return new Promise(async (resolve, reject) => {
        try {

            let response = await fetch(buildRequest(`/api/v${API.version}${url}`, props), {
                headers: utils.api.headers(),
                method: 'GET',
                withCredentials: true
            });

            // determine if response code represents a 5xx level error
            if([502, 503, 504].includes(response.status)) {
                throw new Error('Please try again in a few minutes');
            }

            // prevent moving forward if an error was thrown
            if(response.status !== 200) {
                let text = await response.text();
                let error = new Error(text || 'An unknown error occurred');
                error.code = response.status;
                throw error;
            }

            let json = await response.json();
            resolve(json);

        } catch(e) {
            reject(e);
        }
    });
}

const post = (utils, endpoint, props, options = {}) => {
    return new Promise(async (resolve, reject) => {
        try {

            // determine if a post with download was requested
            if(options?.response_type === 'file_download') {
                
                // build url and xml request
                let xhr = new XMLHttpRequest();
                xhr.open('POST', `${API.server}/api/v${API.version}${endpoint}`);
                xhr.withCredentials = true;

                // set authentication headers for request
                let headers = utils.api.headers();
                Object.keys(headers).filter(key => key !== 'Content-Type').forEach(key => xhr.setRequestHeader(key, headers[key]));

                // send request to server declare event handlers for response
                xhr.send(JSON.stringify(props));
                xhr.onerror = () => {
                    reject(new Error('Network request failed'));
                };
                xhr.onreadystatechange = () => {
                    if(xhr.readyState == 2) {
                        xhr.responseType = xhr.status == 200 ? 'blob' :'text';
                    }
                    if(xhr.readyState == 4) {

                        // prevent moving forward if any other status than success is returned
                        if(xhr.status !== 200) {
                            let error = new Error(xhr.responseText || 'An unknown error occurred');
                            reject(error);
                            return;
                        }
                        
                        // check for conflicts and allow user to respond
                        if(xhr.status === 409) {
                            let error = new Error();
                            error.code = xhr.status;
                            error.category = xhr.response.category;
                            error.message = xhr.response.message;
                            error.response = xhr.response;
                            reject(error);
                            return;
                        }

                        // prepare link element for automatic download
                        let fileName = xhr.getResponseHeader('Content-Disposition')?.split('attachment;filename=')[1];
                        resolve({ 
                            file_name: fileName,
                            url: window.URL.createObjectURL(xhr.response) 
                        });
                    }
                }
                return;
            }

            // prepare and submit request to sever
            let response = await fetch(`/api/v${API.version}${endpoint}`, {
                method: 'POST',
                withCredentials: true,
                headers: utils.api.headers(),
                body: JSON.stringify(props)
            });

            // determine if response code represents a 5xx level error
            if([502, 503, 504].includes(response.status)) {
                throw new Error('Please try again in a few minutes');
            }

            // prevent moving forward if an error was thrown
            if(response.status !== 200) {
                let text = await response.text();
                let error = new Error(text || 'An unknown error occurred');
                error.code = response.status;
                throw error;
            }

            let json = await response.json();
            resolve(json);

        } catch(e) {
            reject(e);
        }
    });
}

const Request = {
    get: get,
    post: post
}
export default Request;
